<template>
  <ul class="slds-accordion">
    <slot />
  </ul>
</template>
<script>
export default {

}
</script>
